// extracted by mini-css-extract-plugin
export var footer = "SideMenu-module--footer--2e3fd";
export var link = "SideMenu-module--link--4baa8";
export var links = "SideMenu-module--links--117f5";